import { apiClient, invalidateCache } from './client';

/**
 * Get lessons for a course.
 * @param {string} courseId
 * @param {{ page?, limit?, sortBy?, sortOrder? }} params
 */
export async function getLessons(courseId, params = {}) {
  const { data } = await apiClient.get(`/lessons/courses/${courseId}`, { params });
  return data;
}

/**
 * Create lesson.
 * @param {string} courseId
 * @param {object} body - title, description?, content?, orderIndex?, videoUrl?, videoDuration?
 */
export async function createLesson(courseId, body) {
  const { data } = await apiClient.post(`/lessons/courses/${courseId}`, body);
  return data;
}

/**
 * Update lesson.
 * @param {string} courseId
 * @param {string} lessonId
 * @param {object} body
 */
export async function updateLesson(courseId, lessonId, body) {
  const { data } = await apiClient.put(`/lessons/${lessonId}`, body);
  return data;
}

/**
 * Get single lesson
 * @param {string} courseId
 * @param {string} lessonId
 */
export async function getLesson(courseId, lessonId) {
  const { data } = await apiClient.get(`/lessons/${lessonId}`);
  return data;
}

/**
 * Delete a lesson
 * @param {string} courseId
 * @param {string} lessonId
 */
export async function deleteLesson(courseId, lessonId) {
  const { data } = await apiClient.delete(`/lessons/${lessonId}`);
  return data;
}

/**
 * Reorder a course's lessons in one transaction.
 * The backend rewrites orderIndex as 0..n-1 in the order given and rejects (400) a list that is
 * not every non-deleted lesson of the course exactly once, so pass the whole course, not a filtered view.
 * @param {string} courseId
 * @param {string[]} lessonIds - every lesson id of the course, in the new order
 */
export async function reorderLessons(courseId, lessonIds) {
  const { data } = await apiClient.post(`/courses/${courseId}/lessons/reorder`, { lessonIds });
  // The client only clears the cache entries that share this POST's URL (/courses/:id/lessons/...),
  // not the /lessons/courses/:id list this page reads, so drop that one too.
  invalidateCache(`*/lessons/courses/${courseId}*`);
  return data;
}

// There is deliberately no video upload call here. The backend's /lessons/:id/video-upload-url and
// /video-confirm store a bare S3 key as videoMediaId, which the HLS proxy cannot stream, and nothing
// transcodes an uploaded file. Lesson videos are attached by an admin (admin panel > Media library >
// Import existing); CourseLessons explains this on the video action.
